<template>
  <div>
    <div class="container-fluid">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="bold text-secondary-light m-0">
          Availability & Preferences
        </h6>
        <i
          class="fa-solid fa-pen-to-square text-primary"
          v-if="isEditable"
          @click="editAvailabilityInfo"
        ></i>
      </div>

      <div class="br-8 table-scroll-wrapper">
        <table
          class="table table-inner-bordered m-0 align-middle text-start bg-blue-light-2 br-8"
        >
          <tbody>
            <tr>
              <td>
                <span class="text-primary d-block">Preferred Region</span>
                <span
                  :class="
                    preferredRegion ? 'text-secondary bold' : 'text-muted'
                  "
                >
                  {{ preferredRegion || "N/A" }}
                </span>
              </td>
              <td>
                <span class="text-primary d-block">Preferred Country</span>
                <span
                  :class="
                    preferredCountry ? 'text-secondary bold' : 'text-muted'
                  "
                >
                  {{ preferredCountry || "N/A" }}
                </span>
              </td>
              <td>
                <span class="text-primary d-block">Notice Period</span>
                <span
                  :class="noticePeriod ? 'text-secondary bold' : 'text-muted'"
                >
                  {{ noticePeriod }}
                </span>
              </td>
              <td>
                <span class="text-primary d-block">
                  {{
                    profile.available
                      ? "Join Date/Availability"
                      : "Available From"
                  }}
                </span>
                <span
                  :class="
                    profile.available ? 'text-secondary bold' : 'text-muted'
                  "
                >
                  {{ profile.available ? expectedJoinDate : availableFrom }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="text-primary d-block">Current Salary</span>
                <span
                  :class="salaryCurrent ? 'text-secondary bold' : 'text-muted'"
                >
                  {{ salaryCurrent || "N/A" }}
                </span>
              </td>
              <td>
                <span class="text-primary d-block">Expected Salary</span>
                <span
                  :class="
                    salaryExpectation ? 'text-secondary bold' : 'text-muted'
                  "
                >
                  {{ salaryExpectation || "N/A" }}
                </span>
              </td>
              <td>
                <span class="text-primary d-block">Preferred Contract</span>
                <span :class="contract ? 'text-secondary bold' : 'text-muted'">
                  {{ contract || "N/A" }}
                </span>
              </td>
              <td v-if="isRecruiterOrAdmin">
                <span class="text-primary d-block">Total Budget</span>
                <span
                  :class="
                    allocatedBudget || total_budget_currency
                      ? 'text-secondary'
                      : 'text-muted'
                  "
                >
                  {{ allocatedBudget }} {{ total_budget_currency }}
                </span>
              </td>
            </tr>
            <tr>
              <td v-if="isRecruiterOrAdmin">
                <span class="text-primary d-block">
                  No. of Positions Available
                </span>
                <span
                  :class="
                    positionsAvailable ? 'text-secondary bold' : 'text-muted'
                  "
                >
                  {{ positionsAvailable || "N/A" }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <AvailabilityInfoEdit
        :candidateInfo="profile"
        :isShowPopup="EditModal.isShowPopup"
        @modalCallBack="availiabilityInfoModalCallBack"
        v-if="EditModal.isShowPopup"
      />
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { Role, getScope } from "@/helpers/helper";
import AvailabilityInfoEdit from "./EditForm/AvailabilityInfoEdit";
import { mapActions, mapGetters } from "vuex";
import profile from "../AddJobs/profile";
import isJobSupplier from "@/mixins/isJobSupplier";
export default {
  mixins: [isJobSupplier],
  props: {
    profile: {
      type: Object,
      default: null,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AvailabilityInfoEdit,
  },
  data() {
    return {
      currentUserRole: getScope(),
      Role,
      EditModal: {
        isShowPopup: false,
      },
      showMore: false,
    };
  },
  computed: {
    ...mapGetters([
      "getCandidatePreferredRegionList",
      "getCandidatePreferredCountryList",
      "currentUserType",
      "getCurrencyForSelectedID",
    ]),
    availableEmployment() {
      if (this.profile.available != null)
        return this.profile.available ? "Yes" : "No";
      return "--";
    },
    preferredCountry() {
      if (this.getCandidatePreferredCountryList.length)
        return this.getCandidatePreferredCountryList
          .map((ele) => {
            return ` ${ele.label}`;
          })
          .toString();
      return "--";
    },
    preferredRegion() {
      if (this.getCandidatePreferredRegionList.length)
        return this.getCandidatePreferredRegionList
          .map(({ label }) => {
            return ` ${label}`;
          })
          .toString();
      return "--";
    },
    noticePeriod() {
      if (this.profile.notice_period_days != null)
        return this.profile.notice_period_days + " Days";
      return "--";
    },
    salaryCurrent() {
      let currentSalary = `${this.profile?.current_salary || "-"} ${
        this.profile?.current_salary_currency?.currency_code || ""
      }`;
      return `${currentSalary}`;
    },
    salaryExpectation() {
      let expextedSalary = `${this.profile?.salary_expectation_min || ""}-${
        this.profile.salary_expectation_max || ""
      } ${this.profile?.salary_expectation_currency?.currency_code || ""}`;
      return `${expextedSalary}`;
    },
    contract() {
      return `${this.profile.job_type || "--"} - ${
        this.profile.job_time || "--"
      }`;
    },
    expectedJoinDate() {
      return this.profile.available_from
        ? moment(this.profile.available_from).format("DD-MMM-YYYY")
        : "--";
    },
    availableFrom() {
      return this.profile.available_from
        ? moment(this.profile.available_from).format("DD-MMM-YYYY")
        : "--";
    },
    allocatedBudget() {
      return this.profile?.allocated_budget || "--";
    },
    positionsAvailable() {
      return this.profile?.positions_available || "--";
    },
    total_budget_currency() {
      return this.getCurrencyForSelectedID(
        this.profile?.allocated_budget_currency_id
      ).map((val) => val.label)[0];
    },
    isRecruiterOrAdmin() {
      return !this.currentUserRole.includes(Role.customerCandidate)
    }
  },
  filters: {
    moment: function (date) {
      if (date) return moment(date).format("DD-MMM-YYYY");
      return "--";
    },
  },
  methods: {
    ...mapActions([
      "fetchCandidatePreferredRegionList",
      "fetchCandidatePreferredCountryList",
      "updateCandidate",
      "deletePreferredRegion",
      "deletePreferredCountry",
      "createPreferredCountry",
      "createPreferredRegion",
    ]),
    editAvailabilityInfo() {
      this.EditModal.isShowPopup = true;
    },
    availiabilityInfoModalCallBack(action, data) {
      if (action === false) this.EditModal.isShowPopup = false;
      if (action === true) {
        let { customer_uid } = this.profile;
        let { candidate_data, region_data, country_data } = data;
        let appendAction = [];
        appendAction = [
          ...appendAction,
          this.updateCandidate({ data: candidate_data, customer_uid }),
        ];
        if (region_data != undefined) {
          this.getCandidatePreferredRegionList.forEach((region) => {
            appendAction = [
              ...appendAction,
              this.deletePreferredRegion(region.preferred_region_id),
            ];
          });
        }
        if (region_data != undefined && region_data.length) {
          region_data.forEach((region, index) => {
            let region_payload = {
              region_id: region,
              preference: index + 1,
              comments: null,
            };
            appendAction = [
              ...appendAction,
              this.createPreferredRegion(region_payload),
            ];
          });
        }
        if (country_data != undefined) {
          this.getCandidatePreferredCountryList.forEach((country) => {
            appendAction = [
              ...appendAction,
              this.deletePreferredCountry(country.preferred_country_id),
            ];
          });
        }
        if (country_data != undefined && country_data.length) {
          country_data.forEach((country_id, index) => {
            let country_payload = {
              country_id,
              preference: index + 1,
              comments: null,
            };
            appendAction = [
              ...appendAction,
              this.createPreferredCountry(country_payload),
            ];
          });
        }
        Promise.all([appendAction]).then((res) => {
          setTimeout(() => {
            this.fetchCandidatePreferredRegionList();
            this.fetchCandidatePreferredCountryList();
          }, 500);
          this.EditModal.isShowPopup = false;
        });
      }
    },
    ShowMoreLess() {
      this.showMore = !this.showMore;
    },
  },
};
</script>
